import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleFillError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.75 5.25L5.25 10.75M5.25 5.25L10.75 10.75",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export default SvgCircleFillError;
